import { keyframes, styled } from 'styled-components';

export const ProgressContainer = styled.div`
  width: 100%;
  height: 0.6rem;
  flex-shrink: 0;

  background-color: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

export const progressAnimation = keyframes`
  from {
    width: var(--start-width);
  }
  to {
    width: var(--end-width);
  }
`;

export const ProgressBar = styled.div<{ $start: number; $end: number }>`
  height: 100%;
  background-color: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundText};
  border-radius: ${({ theme }) => theme.spacing(2)};

  // Set the CSS variables with the start and end values to be used in the keyframes.
  --start-width: ${({ $start }) => $start}%;
  --end-width: ${({ $end }) => $end}%;

  width: var(--end-width);

  // Apply the animation which now reads the CSS variables.
  animation: ${progressAnimation} 0.5s ease-in-out;
`;
